export default "__VITE_ASSET__84a9bbb2__"